<template>
  <section>
    <div class="wrapper">
      <div
        v-if="isFocused"
        :class="{ title: !isFilled, title_focus: isFocused }"
      >
        {{ prop.placeholder }}
      </div>
      <div
        v-else-if="
          !isFocused && isFilled && !errorMsg && !errorMessage && !prop.disabled
        "
        class="title"
      >
        {{ prop.placeholder }}
      </div>
      <div
        v-else-if="!isFocused && isFilled && !errorMessage && prop.disabled"
        class="titleDisabled"
      >
        {{ prop.placeholder }}
      </div>
      <div
        v-else-if="(errorMessage && prop.disabled) || !fill"
        class="titleError"
      >
        {{ prop.placeholder }}
      </div>
      <!-- 
        :placeholder="$props.placeholder + ' (DD/MM/YYYY)'" 
      :editable="true"
              @inputError="handlerError"
              :placeholder="$props.placeholder"
      -->
      <DatePicker
        v-model:value="inputValue"
        value-type="format"
        format="DD/MM/YYYY"
        class="date"
        :class="{
          'placeholder-text': !inputValue,
          focused: isFocused,
          inputError: errorMessage,
          dateDisabled: prop.disabled,
        }"
        :placeholder="$props.placeholder + '(dd/mm/yyyy)'"
        :editable="true"
        @inputError="handlerError"
        required
        :disabled="disabled"
        :disabled-date="disableFuturePastDates"
        name="date"
        @change="emitSelectedDate"
        @focusout="handleBlurOut"
        @focus="handleFocus"
        @mousedown.stop="handleClick"
        @input="handleInput"
        :clearable="false"
        :placement="'bottom'"
        :picker-options="{ position: 'bottom' }"
        v-on="validationListeners"
        :default-value="defaultDate"
        :default-panel="'year'"
        @clear=""
        :autocomplete="autocomplete"
        ref="datePickerRef"
        v-dateFormat
      />
    </div>
    <!-- <pre class="help" v-if="!errorMessage"> {{ errorMessage }}</pre> -->
    <pre class="help"> {{ errorMessage }}</pre>
  </section>
</template>

<script setup lang="ts">
import { ref, nextTick, computed, watch, onMounted } from "vue";
import DatePicker from "vue-datepicker-next";
import { useField } from "vee-validate";
import i18n from "@/plugin/i18n";
const { t } = i18n.global;

const emits = defineEmits(["update:dateSelected"]);
const datePickerRef = ref();
const prop = defineProps({
  placeholder: {
    type: String,
    required: true,
  },
  dateSelected: {
    type: String,
  },
  required: {
    type: Boolean,
    default: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  field: {
    type: String,
    required: true,
  },
  validateRule: {
    type: String,
  },
  defaultValue: {
    type: String,
  },
  autocomplete: {
    type: String,
  },
});

const isFocused = ref(false);
const isFilled = ref(false);

const inputValue = ref(prop.dateSelected || "");

const setMaxLength = () => {
  nextTick(() => {
    const datePickerInput = datePickerRef.value?.$el?.querySelector("input");
    if (datePickerInput) {
      datePickerInput.setAttribute("maxlength", 10); // Set to 10 for DD/MM/YYYY
    }
  });
};

onMounted(() => {
  setMaxLength();
});

const disableFuturePastDates = (date: Date) => {
  const today = new Date();
  const pastLimit = new Date("01/01/1900");
  return date > today || date < pastLimit;
};

const handleInput = (event: any) => {
  const inputElement = event.target as HTMLInputElement;
  const start = inputElement.selectionStart;
};

const handlerError = (e: any) => {
  inputValue.value = "";
  errorMsg.value = true;
  emits("update:dateSelected", "");
  // errorMessage.value = "";
  setErrors(t("ccOnBoarding.basicInformation.errorInvalidDate"));
};

const defaultDate = computed(() => {
  if (prop.defaultValue !== "" && prop.defaultValue != undefined) {
    const currentYearLastTwoDigits = parseInt(
      new Date().getFullYear().toString().slice(-2),
      10
    );
    const defaultValueYear = parseInt(prop.defaultValue.substring(0, 2), 10);

    let adjustedYear: string;

    if (currentYearLastTwoDigits - defaultValueYear > 0) {
      adjustedYear = "20" + prop.defaultValue.substring(0, 2);
    } else {
      adjustedYear = "19" + prop.defaultValue.substring(0, 2);
    }

    const day = parseInt(prop.defaultValue.substring(4, 6), 10);
    const month = parseInt(prop.defaultValue.substring(2, 4), 10);

    const isValidDate = day >= 1 && day <= 31 && month >= 1 && month <= 12;
    if (isValidDate) {
      const formattedDate =
        prop.defaultValue.substring(4, 6) +
        "/" +
        prop.defaultValue.substring(2, 4) +
        "/" +
        adjustedYear;
      emits("update:dateSelected", formattedDate);
      inputValue.value = formattedDate;
      isFilled.value = true;
      return formattedDate;
    } else {
      return "";
    }
  }
  emits("update:dateSelected", "");
  inputValue.value = "";
  return "";
});
const { value, errorMessage, handleBlur, setErrors } = useField(
  () => prop.field,
  prop.validateRule,
  {
    validateOnValueUpdate: true,
  }
);
const errorMsg = ref(false);
const fill = ref(true);
const validationListeners = {
  focusout: (evt: Event | undefined) => {
    // Check if prop.dateSelected is empty or null
    if (!prop.dateSelected && errorMsg.value != true) {
      setTimeout(() => {
        setErrors(t("This field is required"));
      }, 50);
      fill.value = false;
      // handleBlur(evt, true);
    } else if (!prop.dateSelected && errorMsg.value == true) {
      // errorMessage.value = "";
      setTimeout(() => {
        setErrors(t("ccOnBoarding.basicInformation.errorInvalidDate"));
      }, 50);
      // handleBlur(evt, true);
    } else if (prop.dateSelected != "") {
      // handleBlur(evt, false);
    } else {
      fill.value = true;
      errorMsg.value = false;

      // handleBlur(evt, false);
    }
  },
};
// Define the emit function
// Emit the selected date when a date is selected

const emitSelectedDate = (e: any) => {
  isFocused.value = false;
  isFilled.value = true;
  // Check if there's an invalid date in dataset
  const invalidDate =
    datePickerRef.value.childNodes[0].childNodes[0].dataset.invalid;
  // const invalidDateParts = invalidDate ? invalidDate.split("/") : [];
  // Check specific invalid dates to allow
  // const passDates = [
  //   "31/01",
  //   "31/03",
  //   "31/05",
  //   "31/07",
  //   "31/08",
  //   "31/10",
  //   "31/12",
  // ];
  // const dayMonth =
  //   invalidDateParts.length >= 2
  //     ? `${invalidDateParts[0]}/${invalidDateParts[1]}`
  //     : "";
  if (invalidDate) {
    // if (passDates.includes(dayMonth)) {
    //   // Valid date, clear error state
    //   errorMsg.value = false;
    // } else {
    // Invalid date, handle error state
    inputValue.value = "";
    errorMsg.value = true;
    handlerError(e);
    return;
    // }
  }
  emits("update:dateSelected", inputValue.value.substring(0, 10));
  datePickerRef.value.childNodes[0].childNodes[0].value =
    inputValue.value.substring(0, 10);
};

// function isValidCalendarDate(
//   day: number,
//   month: number,
//   year: number
// ): boolean {
//   const date = new Date(year, month - 1, day);
//   return (
//     date.getFullYear() === year &&
//     date.getMonth() === month - 1 &&
//     date.getDate() === day
//   );
// }

const handleFocus = (event: any) => {
  errorMsg.value = false;
  if (prop.disabled) {
    event.preventDefault;
  } else {
    isFocused.value = true;
    isFilled.value = false;
  }
};

const handleClick = (event: any) => {
  if (prop.disabled) {
    event.preventDefault;
  } else {
    setTimeout(() => {
      isFocused.value = true;
      isFilled.value = true;
    }, 0);
  }
};

const handleBlurOut = () => {
  if (inputValue.value == "") {
    isFilled.value = false;
    isFocused.value = false;
  } else {
    isFilled.value = true;
    errorMsg.value = false;
    isFocused.value = false;
  }
};

const placeholderHidden = computed(() => {
  return isFocused.value ? "" : prop.placeholder;
});

if (inputValue.value != "") {
  value.value = inputValue.value;
}

watch(inputValue, (newValue) => {
  value.value = newValue;
});
</script>

<style lang="css" scoped>
.wrapper {
  position: relative;
}

.help {
  color: red;
  margin-bottom: 0px;
  margin-top: 8px;
  font: 400 16px/130% "Outfit", sans-serif;
  word-wrap: break-word; /* Or use word-break: break-word; */
  white-space: pre-wrap;
}

.date {
  border: 2px solid #dbdfea;
  /* padding: 6px 31px 6px 22px; */
  border-radius: 10px;
  width: 100%;
  color: rgba(0, 0, 0, 0.87);
  font: 400 16px/130% "Outfit", sans-serif;
  outline-color: #ac2887;
}

.date-disabled {
  border: 2px solid #dbdfea;
  width: 100%;
  color: rgba(0, 0, 0, 0.87);
  font: 400 16px/130% "Outfit", sans-serif;
  text-shadow: none;
  box-shadow: none;
  -webkit-text-fill-color: initial;
  pointer-events: none;
}

.inputError {
  border: 2px solid red;
  border-radius: 10px;
  width: 100%;
  color: rgba(0, 0, 0, 0.87);
  font: 400 16px/130% "Outfit", sans-serif;
  outline-color: #ac2887;
}

.date.focused {
  border-color: #ac2887;
}

.date:focus {
  box-shadow: none;
}

.date::placeholder {
  color: var(--black-low-38, rgba(0, 0, 0, 0.38));
  font: var(--subtitle-1-medium, 500 16px/130% "Outfit", sans-serif);
}
.title {
  position: absolute;
  top: -8px;
  left: 15px;
  color: rgba(0, 0, 0, 0.38);
  font: 500 12px/130% "Outfit", sans-serif;
  background-color: white;
  padding: 0 5px;
  z-index: 9999;
}

.dateDisabled {
  background-color: #dbdfea !important;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.title_focus {
  position: absolute;
  top: -8px;
  left: 15px;
  color: #ac2887;
  font: 500 12px/130% "Outfit", sans-serif;
  background-color: white;
  padding: 0 5px;
  opacity: 0;
  transform: translateY(100%);
  z-index: 2;
  /* Animation */
  animation: slideIn 0.3s ease-out forwards;
}

.titleError {
  position: absolute;
  top: -8px;
  left: 15px;
  color: red;
  font: 500 12px/130% "Outfit", sans-serif;
  background-color: white;
  padding: 0 5px;
  z-index: 1;
}

.date-picker-container {
  position: absolute;
  top: auto !important;
  bottom: 0;
}

.titleDisabled {
  position: absolute;
  top: -8px;
  left: 15px;
  color: rgba(0, 0, 0, 0.38);
  font: 500 12px/130% "Outfit", sans-serif;
  background: linear-gradient(to bottom, white 52%, #dbdfea 48%);
  padding: 0 5px;
  z-index: 9999;
}
</style>
